import Raven from 'raven-js';

export default () => {
  if (process.env.NODE_ENV === 'production' && !!window.__SENTRY__) {
    const { dsn, release, environment } = window.__SENTRY__;

    console.log(
      `Configuring Raven for release: ${release} on environment: ${environment}`
    );

    try {
      Raven.config(dsn, {
        release,
        environment,
      }).install();

      handlePromiseRejection();
    } catch (error) {
      console.warn(`Invalid Sentry DSN provided: ${dsn}`);
    }
  }
};

function handlePromiseRejection() {
  window.onunhandledrejection = evt => {
    Raven.captureException(evt.reason, {
      level: 'warning',
    });
  };
}



// WEBPACK FOOTER //
// ./src/raven/index.js